module.exports = __webpack_public_path__ + "img/glassquality_5.a30e39c9.png";